import "./premiums.css";
import Spinner from "@src/components/spinner";
import { Drawer, Form, Input, InputNumber, Select } from "antd";
import { useMutation } from "@apollo/client";
import { faChevronDown, faChevronUp, faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setNotification } from '@src/middleware/redux/reducers/notification.reducer';
import { newPremiumMutation, updatePremiumMutation } from "../../../../util/mutation/premium.mutation";
import { CaretDownFilled } from "@ant-design/icons";


export const PremiumModal = ({visible, close, refetch:refetchPremiums, editPremium})=>{
    

    const {Option} = Select;

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [premiumUnit, setPremiumUnit] = useState("");
    const [payType, setPayType] = useState("amount");
    const [billType, setBillType] = useState("amount");
    const [payAmount, setPayAmount] = useState();
    const [billAmount, setBillAmount] = useState(0);

    useEffect(()=>{
        if(editPremium && Object.keys(editPremium)?.length>0){
            console.log(editPremium, "editPremium");
            setName(editPremium?.name);
            setDescription(editPremium?.description);
            setPayAmount(editPremium?.payamount_percentage);
            setBillAmount(editPremium?.billamount_percentage);
            setPremiumUnit(editPremium?.premiumunit);
            setPayType(editPremium?.paytype);
            setBillType(editPremium?.billtype);

        }
    },[editPremium]);



    const dispatch = useDispatch();


    const [newPremium, {loading: newPremiumLoading}] = useMutation(newPremiumMutation);
    
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    useEffect(()=>{
        if(name?.length>0 && payAmount>0 && billAmount>-1){
                setIsSubmitDisabled(false);
        }else{
            setIsSubmitDisabled(true);
        }
    },[name, payAmount, billAmount]);

    const [updatePremium, {loading:updatePremiumLoading}] = useMutation(updatePremiumMutation);

    const handelSubmit = async ()=>{
        try{
            const premiumInput = {
                name, 
                description,
                payAmount,
                billAmount, 
                premiumUnit,
                payType,
                billType,
            };

            if(Object.keys(editPremium)?.length>0){
                await updatePremium({
                    variables:{
                        input: {...premiumInput, _id: editPremium?._id}
                    }
                });
                dispatch(setNotification({
                    error: false,
                    notificationState: false,
                    message: "Premium was updated successfully"
                }));

            }else{

                await newPremium({
                    variables:{
                        input: premiumInput
                    }
                });
                dispatch(setNotification({
                    error: false,
                    notificationState: false,
                    message: "Premium was added successfully"
                }));
            }


            close();
            await refetchPremiums();

        }catch(err){
            dispatch(setNotification({
                error: true,
                notificationState: true,
                message: "An error encountered while adding premium "+err.message
            }));
        }
    };


    return(
        <Drawer
            open={visible}
            placement="right"
            title={"Add Premiums"}
            width={600}
            footer={
            <div className='drawer-footer' style={{display:'flex',gap:'20px'}}>
                <button  
                    onClick={isSubmitDisabled || newPremiumLoading || updatePremiumLoading?null:handelSubmit}
                    className={newPremiumLoading || isSubmitDisabled || updatePremiumLoading? 'disabled-btn drawer-filled-btn' : 'drawer-filled-btn'} 
                >
                    { newPremiumLoading || updatePremiumLoading? <Spinner/>: "Save"}
                </button>
                <button  className={ newPremiumLoading || updatePremiumLoading? 'disabled-btn drawer-outlined-btn':'drawer-outlined-btn'} onClick={close}>
                    Cancel
                </button>
            </div>
            }
            closable={true}
            onClose={newPremiumLoading || updatePremiumLoading? ()=>{} :close}
            closeIcon={<FontAwesomeIcon disabled={newPremiumLoading || updatePremiumLoading} icon={faClose} onClick={close} className='close-icon'/>}
            maskClosable={false}
            mask={true}
        >

           

                <div style={{display:'flex', gap:'30px'}} className="premiumModal">

                    <div  style={{width:'100%'}}>

                        <Form.Item 
                            required={true}
                            message={"Name is required"}
                        >
                            <label>Name <sup>*</sup></label>
                            <Input placeholder="Name" className="generic-input-control "  onChange={(e)=>setName(e.target.value)} value={name}/>
                        </Form.Item>                 


                        <Form.Item >
                            <label>Description</label>
                            <Input placeholder="Description" className="generic-input-control " onChange={(e)=>setDescription(e.target.value)} value={description}/>
                        </Form.Item>

                        <Form.Item >
                            <label>Premium Unit</label>
                            <Select
                                className="custom-select"
                                onChange={(e)=>setPremiumUnit(e)}
                                value={premiumUnit}
                                suffixIcon={<CaretDownFilled/>}
                            >
                                <Option value="shift">Per Shift</Option>
                                <Option value="hour">Per Hour</Option>
                            </Select>
                        </Form.Item>


                        {/* Pay Section */}
                        <Form.Item>
                            <label>Pay Type</label>
                            <Select
                                value={payType}
                                onChange={(val) => setPayType(val)}
                                className="custom-select"
                                suffixIcon={<CaretDownFilled/>}
                            >
                                <Option value="amount">Amount</Option>
                                <Option value="percentage">Percentage (%)</Option>
                            </Select>
                        </Form.Item>


                        <Form.Item >
                            <label>Pay amount <sup>*</sup></label>
                            <InputNumber 
                                min={0}
                                upHandler={<FontAwesomeIcon style={{color:'#0091ae'}} icon={faChevronUp} />}
                                downHandler={<FontAwesomeIcon  style={true > 1 && {color:'#0091ae'}} icon={faChevronDown} />}
                                className="generic-input-control "
                                onChange={(e)=>setPayAmount(e)} 
                                value={payAmount} 
                            />
                        </Form.Item>


                        {/* Bill Section */}
                        <Form.Item>
                            <label>Bill Type</label>
                            <Select
                                value={billType}
                                onChange={(val) => setBillType(val)}
                                className="custom-select"
                                suffixIcon={<CaretDownFilled/>}
                            >
                                <Option value="amount">Amount</Option>
                                <Option value="percentage">Percentage (%)</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item >
                            <label>Bill amount <sup>*</sup></label>
                            <InputNumber 
                                min={0}
                                upHandler={<FontAwesomeIcon style={{color:'#0091ae'}} icon={faChevronUp} />}
                                downHandler={<FontAwesomeIcon  style={true > 1 && {color:'#0091ae'}} icon={faChevronDown} />}
                                className="generic-input-control "
                                onChange={(e)=>setBillAmount(e)} value={billAmount} 
                            />
                        </Form.Item>
                 
                        

                    </div>

                </div>
            



        </Drawer>
    );
}